import { render, staticRenderFns } from "./PanelFacturacion.vue?vue&type=template&id=8b356d18&"
import script from "./PanelFacturacion.vue?vue&type=script&lang=js&"
export * from "./PanelFacturacion.vue?vue&type=script&lang=js&"
import style0 from "./PanelFacturacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports